import { CanvasData, Config, D3Group, Point } from "@/types";
import * as d3 from "d3";

export const initSvg = (element: SVGElement) => {
    const main = d3.select(element);
    main.selectAll("*").remove();

    const pointsGroup = main.append("g").attr("class", "g-points");
    const cellsGroup = main.append("g").attr("class", "g-cells");
    return {
        main,
        pointsGroup,
        cellsGroup,
    };
};

export const drawPoints = (group: D3Group, points: Point[]) => {
    group
        .selectAll("circle")
        .data(points)
        .enter()
        .append("circle")
        .attr("cx", (d) => d.x)
        .attr("cy", (d) => d.y)
        .attr("r", 1)
        .attr("fill", "black");
};

export const drawCells = (
    group: D3Group,
    points: Point[],
    canvasData: CanvasData,
    config: Config
) => {
    const colors = [
        "#B22222", // Firebrick Red
        "#FF4500", // OrangeRed
        "#FFD700", // Gold / amber
        "#1E90FF", // Dodger Blue
        "#4682B4", // Steel Blue
        "#32CD32", // Lime Green / smaragdachtig
        "#800080", // Purple
        "#8B008B", // Dark Magenta
        "#FF69B4", // Hot Pink
        "#FF8C00", // Dark Orange
    ];

    const getRandomColor = () => {
        return colors[Math.floor(Math.random() * colors.length)];
    };
    const coords = points.map((p) => [p.x, p.y]);

    // @ts-expect-error d3 typings kloppen hier niet
    const delaunay = d3.Delaunay.from(coords);
    const voronoi = delaunay.voronoi([
        0,
        0,
        canvasData.size.width,
        canvasData.size.height,
    ]);

    group
        .selectAll("path.voronoi-cell")
        .data(coords)
        .join("path")
        .attr("class", "voronoi-cell")
        .attr("d", (d, i) => voronoi.renderCell(i)) // renderCell(i) geeft SVG path-string
        .attr("fill", (d, i) => {
            if (config.stainedGlass) {
                const poly = voronoi.cellPolygon(i);
                return poly && Math.abs(d3.polygonArea(poly)) < 100
                    ? getRandomColor()
                    : "none";
            } else {
                return "none";
            }
        })
        .attr("fill-opacity", 0.5)
        .attr("stroke", "#444")
        .attr("stroke-width", 1);
};
